const fa = {
  login_or_signup: 'ورود یا ثبت نام',
  enter_mobile_number: 'برای ورود یا ثبت نام شماره موبایل خود را وارد کنید.',
  continue: 'ورود',
  server_error: 'خطای سرور',
  mobile_placeholder: "مثال: ۰۹۱۲۱۲۳۴۵۶۷",
  signup: 'ثبت نام',
  verification_code: 'کد تایید:',
  name: 'نام',
  last_name: 'نام خانوادگی',
  gender: 'جنسیت',
  female: 'زن',
  male: 'مرد',
  verification_sms_sent: 'رمز یکبار مصرف به شماره {{mobile}} پیامک شده است.',
  verify_mobile_number: 'تایید شماره موبایل',
  click_for_changing_mobile:  'برای تغییر شماره اینجا کلیک کنید.',
  login: 'ورود',
  mobile: 'موبایل',
  faq: 'راهنمای استفاده از سامانه',
  frequency_asked_question: 'پرسش و پاسخ‌های متداول',
  back: 'بازگشت',
  time_to_resend_code: 'ثانیه تا ارسال دوباره کد',
  resend_code: 'ارسال مجدد کد'
}

export default fa
